const Log = {
  tx: '\u001B[38;2;57;135;251m',
  sub: '\u001B[38;2;30;194;15m',
  info: '\u001B[38;2;68;124;153m',
}

export const logTx = (...params: unknown[]): void =>
  console.log(`${Log.tx}%s`, ...params)

export const logSub = (...params: unknown[]): void =>
  console.log(`${Log.sub}%s`, ...params)

export const logInfo = (...params: unknown[]): void =>
  console.info(`${Log.info}%s`, ...params)

export const logWarn = (...params: unknown[]): void => console.warn(...params)

export const logError = (...params: unknown[]): void => console.error(...params)
